<script setup lang="ts">
  const props = defineProps<{
    elem: TContent<{
      id: number;
      image_link: string;
      title: string;
      link: string;
    }>;
  }>();

  const elemAttributes = computed(() => props.elem.attributes);
</script>

<template>
  <a
    class="recipe-post-card"
    :href="elemAttributes.link"
    target="_blank"
  >
    <img
      class="recipe-post-card__image"
      :src="elemAttributes.image_link"
      :alt="elemAttributes.title"
    />
    <span
      class="recipe-post-card__title"
      v-html="elemAttributes.title"
    ></span>
  </a>
</template>

<style lang="scss" scoped>
  .recipe-post-card {
    @include print {
      display: none;
    }
    display: flex;
    align-items: center;
    background: white;
    padding: 16px;
    text-decoration: none;
    border: 1px solid #e7e7e7;
    margin: 24px auto 0;
    position: relative;
    color: black;

    &:before {
      content: '';
      position: absolute;
      top: -1px;
      right: -1px;
      left: -1px;
      height: 3px;
      background: $main;
    }

    @include hover {
      &:after {
        content: '';
        position: absolute;
        border: 2px solid $main;
        border-top: none;
        top: 0px;
        bottom: -1px;
        left: -1px;
        right: -1px;
      }
    }

    &__image {
      height: 56px;
      width: 56px;
      max-width: 56px;
      flex: 0 0 56px;
      background: center top / cover no-repeat;
      margin-right: 16px;
      border-radius: 2px;
      object-fit: cover;
    }

    &__title {
      @include fontTextBtn;
      @include lineClampEllipsis(2);
    }
  }
</style>
